export const ROUTES = {
  FORM: 'review_form',
  PAGES: {
    ALL: 'reviews',
  },
}
